import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { API } from '../api';
import { QUERY_KEYS } from '../constants';
import { Agreement } from '../model';

const getAgreementList = (segment: TeliaSegment) =>
    axios.get<Agreement[]>(withParams(API.B2B_AGREEMENTS_LIST, { segment }));

export const useB2BAgreementsQuery = () => {
    const segment = useSegment();

    return useQuery({
        queryKey: [QUERY_KEYS.AGREEMENT_LIST],
        queryFn: () => getAgreementList(segment),
        enabled: segment === TeliaSegment.B2b,
        select: ({ data }) => data,
    });
};
